import { useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { Shield, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ManagerLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !pin) {
      toast.error('Please enter both email and PIN');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/manager/login`, {
        email,
        pin,
      });

      const { token, manager } = response.data;
      onLogin(token, manager);
      toast.success(`Welcome back, ${manager.full_name}!`);
      navigate('/manager/dashboard');
    } catch (error) {
      toast.error(
        error.response?.data?.detail || 'Invalid credentials. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card
        className="w-full max-w-md p-8 bg-white/95 backdrop-blur-sm shadow-2xl"
        data-testid="manager-login-card"
      >
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-gradient-to-br from-gray-900 to-black rounded-full flex items-center justify-center shadow-lg">
              <Shield className="w-10 h-10 text-white" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Manager Login</h1>
          <p className="text-gray-600">Access your management dashboard</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12"
              data-testid="email-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              PIN
            </label>
            <Input
              type="password"
              placeholder="Enter your PIN"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              className="h-12"
              data-testid="pin-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-gradient-to-r from-gray-900 to-black hover:from-gray-800 hover:to-gray-900 text-white shadow-lg"
            data-testid="login-button"
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
          
          <div className="text-center text-sm text-gray-600">
            Forgot your password? Contact your administrator.
          </div>
        </form>

        <div className="text-center mt-6">
          <a
            href="/"
            className="text-sm text-gray-800 hover:text-black flex items-center justify-center gap-2 font-medium"
            data-testid="back-to-clock-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Punch Clock
          </a>
        </div>
      </Card>
    </div>
  );
};

export default ManagerLogin;